import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Routes, useMatch, Link, useLocation, Route } from "react-router-dom";
import AssignTeamsEndpoint from "./AssignTeamsEndpoint";
import UpdateTeamsEndpoint from "./UpdateTeamsEndpoint";
import ReleaseTeamsEndpoint from "./ReleaseTeamsEndpoint";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  title: {
    textAlign: "center",
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const ManageTeamsEndpoint = ({ isAdmin }) => {
  const classes = useStyles();
  const location = useLocation();
  const [value, setValue] = useState(location.pathname);

  const [formData, setFormData] = useState({
    dialPlans: [],
    voicePolicies: [],
    poolsData: [],
    loading: true,
  });

  useEffect(() => {
    Promise.all([
      fetchWithToken("api/getTeamsPools"),
      fetchWithToken("api/Forms/ManageTeamsEndpoint"),
    ])
      .then(([res1, res2]) => Promise.all([res1.json(), res2.json()]))
      .then(([data1, data2]) =>
        setFormData({
          poolsData: data1,
          dialPlans: data2.dialPlans,
          voicePolicies: data2.voicePolicies,
          loading: false,
        })
      );
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Paper className={classes.root}>
        <Typography variant="h5" className={classes.title}>
          Manage Teams Endpoints
        </Typography>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="warning"
          centered
        >
          <Tab
            label="Assign Teams"
            component={Link}
            to={"assign"}
            value={`/manageTeamsEndpoint/assign`}
          />

          <Tab
            label="Update Teams"
            component={Link}
            to={"update"}
            value={`/manageTeamsEndpoint/update`}
          />

          <Tab
            label="Release Teams"
            component={Link}
            to={"release"}
            value={`/manageTeamsEndpoint/release`}
          />
        </Tabs>
      </Paper>
      {formData.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <Routes>
          <Route path={"assign"} element={<Assign isAdmin={isAdmin} />} />
          <Route path={"update"} element={<Update isAdmin={isAdmin} />} />
          <Route path={"release"} element={<Release isAdmin={isAdmin} />} />
        </Routes>
      )}
    </>
  );

  function Assign() {
    return <AssignTeamsEndpoint poolsData={formData.poolsData} />;
  }

  function Update() {
    return (
      <UpdateTeamsEndpoint
        dialPlans={formData.dialPlans}
        voicePolicies={formData.voicePolicies}
      />
    );
  }

  function Release() {
    return <ReleaseTeamsEndpoint />;
  }
};

export default ManageTeamsEndpoint;
